import { useCurrentUser } from "api/user.api";
import { Role } from "types/enums";
import { TransportSedel } from "types/transportSedel.type";
import { Uppdrag } from "types/uppdrag.type";
import { TransportSedelItemWasteList } from "./TransportSedelItemWasteList";
import { ContentContainer, ShadowCard } from "components/ShadowCard";

import { TransportSedelItemDetails } from "./TransportSedelItemDetails";
import { TransportSedelItemOperator } from "./operator/TransportSedelItemOperator";

type Props = {
  transportSedel: TransportSedel;
  uppdrag: Uppdrag;
};
export const TransportSedelItem = ({ transportSedel, uppdrag }: Props) => {
  const { user } = useCurrentUser();

  if (user && user.role <= Role.Operator) {
    return (
      <TransportSedelItemOperator
        transportSedel={transportSedel}
        uppdrag={uppdrag}
      />
    );
  }

  return (
    <ShadowCard className="max-w-[1800px]">
      {/*  */}
      <ContentContainer>
        {/* <MoveToButtonAnimation /> */}
        <TransportSedelItemDetails
          uppdrag={uppdrag}
          transportSedel={transportSedel}
        />
        <TransportSedelItemWasteList
          uppdrag={uppdrag}
          transportSedel={transportSedel}
        />
      </ContentContainer>
    </ShadowCard>
  );
};
